import { createAsyncReducer, createReducerFromMap } from "@coverme/redux";

const initialState = {
    isLoading: false,
    isInitialized: false,
    data: { user: {}, permissions: {} },
};

function getUserPermissions(state, action) {
    let permissionsObj = {};
    for (const permission of action.value) {
        permissionsObj[permission] = true;
    }
    return {
        ...state,
        permissions: permissionsObj,
    };
}

export const userReducer = createReducerFromMap(initialState, {
    ...createAsyncReducer("GET_USER_PERMISSIONS", getUserPermissions),
});
